"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function bela(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.32738 9.09638C6.03381 8.9424 5.78797 8.71102 5.6165 8.42731C5.44504 8.1436 5.35447 7.81838 5.35463 7.48688C5.22644 7.24382 5.15521 6.97479 5.14633 6.70014C5.13745 6.42549 5.19116 6.15242 5.30338 5.90159C5.4156 5.65076 5.5834 5.42874 5.79408 5.25232C6.00476 5.07591 6.25281 4.94972 6.51946 4.88331C6.7861 4.81689 7.06436 4.812 7.33317 4.86899C7.60199 4.92597 7.85433 5.04336 8.07109 5.21225C8.28785 5.38114 8.46336 5.59712 8.58433 5.84385C8.70531 6.09058 8.76859 6.36159 8.76938 6.63638C9.79347 6.0375 10.9588 5.72268 12.1451 5.72438C15.8501 5.72438 18.8546 8.73488 18.8546 12.4474C18.8546 16.1599 15.8509 19.1704 12.1451 19.1704C8.43938 19.1704 5.43563 16.1606 5.43563 12.4474C5.4339 11.2715 5.74143 10.1159 6.32738 9.09638ZM12.1451 15.7549C13.9676 15.7549 15.4451 14.2744 15.4451 12.4474C15.4451 10.6204 13.9676 9.13988 12.1451 9.13988C10.3226 9.13988 8.84513 10.6211 8.84513 12.4474C8.84513 14.2736 10.3226 15.7549 12.1451 15.7549Z", fill: color }));
}
exports["default"] = bela;
//# sourceMappingURL=bela.js.map